export interface IToken {
  dwu: string;
  eim: string;
  exp: number;
  iat: number;
  iss: string;
  lu: string;
  shUser?: string;
}

export enum ClientAccessUserPermission {
  NotAllowed,
  Mobile,
  Portal,
  MobileAndPortal
}

export interface ITokenUser {
  UserId: string;
  BirthDate: string;
  CanEditInterpretation: boolean;
  CanLogIntoPortal: boolean;
  CanManageNonProUsers: boolean;
  CanManageProUsers: boolean;
  CanManageEntities: boolean;
  CanViewEcgs: boolean;
  CanViewReports: boolean;
  CanApproveEcg: boolean;
  ClientApp: number;
  ClientAccessUserPermission: ClientAccessUserPermission;
  AppDeepLink: string;
  ClientSource: string;
  CurrentLang: string;
  DeviceId: number;
  DeviceTypes: number[];
  DistributorId: number;
  FirstName: string;
  IsMale: true;
  IsPhysician: boolean;
  LastName: string;
  Mobile: number;
  Pointer: number;
  Prefix: string;
  RoleID: number;
  ServiceID: number;
  ShowAutoMeasurements: boolean;
  ShowPreview: boolean;
  ShowQtcF: boolean;
  UseMs: boolean;
  UserName: string;
  Organization: {
    OrganizationId: number;
    OrganizationName: string;
    OrganizationType: number;
    IsViewSelfClinicIsAllowed: boolean;
  };
  SignInUrl: string;
  SignOutUrl: string;
  IsSso: boolean;
}
